import {Component, OnDestroy, OnInit} from '@angular/core';
import {GgAuthService} from '../../services/gg-auth.service';
import {HelpersService} from '../../../../services/helpers.service';
import {LOGOS_MOCK} from '../../assets/logos';
import {Router} from '@angular/router';
import {MemberModel, ProjectSettings} from '../../../../models/user.model';
import {Subscription} from 'rxjs';
import {TokenService} from '../../../../services/token.service';

@Component({
    selector: 'app-gg-projects-list',
    templateUrl: './gg-projects-list.component.html',
    styleUrl: './gg-projects-list.component.scss'
})
export class AppGgProjectsListComponent implements OnDestroy, OnInit {
    private subs = new Subscription()
    public userName: string = '';
    private userData!: MemberModel;
    private accessData: {token: string ,expires_in:string} ={token:'',expires_in:''}
    public selectedProjectGuid: string = ''
    public logos = LOGOS_MOCK;

    constructor(
        public ggAuthService: GgAuthService,
        public helperService: HelpersService,
        private router: Router,
        private tokenSerivce: TokenService
    ) {
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }

    ngOnInit(): void {
        this.subs.add(
            this.ggAuthService.loginStateSub.asObservable().subscribe(res => {
                res.userData ? this.userName = this.helperService.fullName(res.userData) : null;
                res.userData ? this.userData = res.userData : null;
                this.accessData.token = res?.token || this.tokenSerivce.getToken()
                this.accessData.expires_in = this.tokenSerivce.getExpireTime()
            }))
    }

    //ToDo - Изменить способ передачи токена. Убрать его из url
    redirectTo(project: ProjectSettings, event: MouseEvent) {
        const q = new URLSearchParams({
            auth_token: this.accessData.token,
            lastpage: window.location.pathname,
            expires_in:this.accessData.expires_in,
        });
        this.selectedProjectGuid = project.project.guid
        const baseDomain = project.project.domain;
        if (this.userData.project_setting.project.domain !== baseDomain) {
            const schema = window.location.href.split('://')[0];
            const url = schema + '://' + baseDomain + window.location.pathname;
            document.location.href = url + '?' + q.toString();
        } else {
            this.router.navigate(['account', 'tasks']);
        }
    }
}
